module.exports = __webpack_public_path__ + "img/AL8000-2.3ce4a59f.jpg";